import React from 'react'
import styles from './style.module.scss'
import { useMediaQuery } from 'react-responsive'

const Copyrights = () => {

  const year = new Date().getFullYear()
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return isMobile ? (
    <div className={styles.copyrightsCont}>
      <p>&#169; {year} Wedage & Company (Pvt) Ltd. All Rights Reserved</p>
      <p>Developed by <a href="https://www.24Streets.com/" target="_blank" rel="noopener noreferrer">24 Streets</a></p>
    </div>
  ) : (
    <div className={styles.copyrightsCont}>
      <p>&#169; {year} Wedage & Company (Pvt) Ltd. All Rights Reserved | Developed by <a href="https://www.24Streets.com/" target="_blank" rel="noopener noreferrer">24 Streets</a></p>
    </div>
  )
}

export default Copyrights